import { gql } from "@apollo/client";

export const FETCH_DCDD_TOTAL_USER = gql`
   query GetDcddUserTotals($from_date:Time, $to_date:Time, $dzongkhag_id:UUID, $category:String) {
    getDcddUserTotals(from_date: $from_date, to_date:$to_date, dzongkhag_id:$dzongkhag_id, category:$category) {
        data {
            total_new
            total_all
            total_active
            total_inactive
        }
        error
    }
}
`;